export const SIGN_DOC =  "Alternatively, you can sign this document by clicking 'view' under Document Signature and clicking 'sign now'.";

export const DOWNLOAD_DOC = "To access your signed copy of the Employee Handbook, click 'download' under Document Signature.";